import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./styles.less";

const Ribbon = ({
  text,
  isRtl,
  shape,
  vertical,
  wrapperClassName,
  textClassName,
  withShadow
}) => {
  return (
    <div
      className={cx(
        styles.ribbon,
        styles[shape],
        styles[vertical],
        {
          [styles.rtl]: isRtl
        },
        wrapperClassName
      )}
    >
      <div
        className={cx(
          styles.text,
          styles[vertical],
          {
            [styles.rtl]: isRtl,
            [styles.shadow]: withShadow
          },
          textClassName
        )}
      >
        {text}
      </div>
    </div>
  );
};

Ribbon.defaultProps = {
  text: "SPECIAL",
  shape: "diagonal",
  vertical: "top",
  withShadow: true,
  wrapperClassName: "",
  textClassName: ""
};

Ribbon.propTypes = {
  shape: PropTypes.oneOf(["diagonal", "horizontal"]),
  vertical: PropTypes.oneOf(["top", "bottom"]),
  text: PropTypes.string,
  isRtl: PropTypes.bool,
  withShadow: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  textClassName: PropTypes.string
};

export default Ribbon;



// WEBPACK FOOTER //
// ./src/components/common/Ribbon/Ribbon.js